export default class Methods {
    public static readonly Get = 'GET';
    public static readonly Put = 'PUT';
    public static readonly Post = 'POST';
    public static readonly Patch = 'PATCH';
    public static readonly Delete = 'DELETE';
    public static readonly Options = 'OPTIONS';
}
